import api from './api';

// Jenn, 2026-10-08: who visited which My Hub page, and student progress per course.
export const getVisitedPages  = (from, to)       => api.get('/admin/page-visits/pages', { params: { from, to } }).then(r => r.data);
export const getWhoVisited    = (page, from, to) => api.get('/admin/page-visits', { params: { page, from, to } }).then(r => r.data);
export const getCourseStudents = (courseId)      => api.get(`/admin/courses/${courseId}/students`).then(r => r.data);
